import { Component, OnInit } from '@angular/core';
import { SubscripcionesService } from '../../services/subscripciones/subscripciones.service';
import { ToastrService } from 'ngx-toastr';
import { FooteWebService } from '../../services/footer-web/foote-web.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
})
export class FooterComponent implements OnInit {
  imagenModal: string;

  photos: any = [
    { img: './assets/imgs/instagram/insta1.webp' },
    { img: './assets/imgs/instagram/insta2.webp' },
    { img: './assets/imgs/instagram/insta3.webp' },
    { img: './assets/imgs/instagram/insta4.webp' },
    { img: './assets/imgs/instagram/insta5.webp' },
    { img: './assets/imgs/instagram/insta6.webp' },
    { img: './assets/imgs/instagram/insta7.webp' },
    { img: './assets/imgs/instagram/insta8.webp' },
    { img: './assets/imgs/instagram/insta9.webp' },
  ];
  email_subscripcion = null;
  footer_list: any[] = [];
  constructor(
    private _subscripcionesServie: SubscripcionesService,
    private _tostrService: ToastrService,
    private _footerWebService: FooteWebService
  ) {}

  imagen = (url) => {
    this.imagenModal = null;
    let imagenModal = url;
    this.imagenModal = imagenModal;
  };

  ngOnInit(): void {
    this._footerWebService.get().subscribe((res: any) => {
      this.footer_list = res.lista;
      console.log('FOOTER', this.footer_list);
    });
    console.log('FOOTER', this.footer_list);
  }
  add_subscripcion() {
    if (!!this.email_subscripcion) {
      this._subscripcionesServie
        .insert({ email: this.email_subscripcion })
        .subscribe((res: any) => {
          this.email_subscripcion = null;
          this._tostrService.success('Corrreo registrado correctamente');
        });
    } else {
      this._tostrService.error('Por favor ingresa un correo');
    }
  }
}
